import React from 'react';
import Hero from '../components/terms-condition/Hero';
import TermsContent from '../components/terms-condition/content';

const Terms = () => {
  return (
    <div>
        <Hero/>
        <TermsContent/>
    </div>
  );
};

export default Terms;
